import { Button, Card, FormGroup } from "@blueprintjs/core";
import { MediaImage } from "@package/ui-apollo-components";
import { type ProfileModel } from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { MediaTagSelector } from "../../../MediaTagSelector/MediaTagSelector";

type ProfileBackgroundMediaListEditorEntryProps = {
  disabled: boolean;
  image?: string | null;
  onImageChanged: (id?: string | null) => void;
  onImageDeleted: () => void;
};

function ProfileBackgroundMediaListEditorEntry({
  disabled = false,
  image,
  onImageChanged,
  onImageDeleted,
}: ProfileBackgroundMediaListEditorEntryProps) {
  return (
    <Card>
      <FormGroup
        disabled={disabled}
        label="Media File"
        labelFor="control-media"
      >
        <div className="mb-2">
          <MediaTagSelector
            fill
            large
            minimal
            disabled={disabled}
            id={image ?? undefined}
            onRemoveMedia={() => {
              onImageChanged(null);
            }}
            onSelectMedia={(mediaId) => {
              onImageChanged(mediaId);
            }}
          />
        </div>
        <MediaImage id={image ?? undefined} />
      </FormGroup>
      <div className="flex flex-row justify-end">
        <Button
          disabled={disabled}
          minimal
          intent="danger"
          text="Remove Background Media"
          onClick={() => onImageDeleted()}
        />
      </div>
    </Card>
  );
}

type ProfileBackgroundMediaListEditorProps = {
  disabled?: boolean;
  profile?: ProfileModel;
  onProfileChanged: (
    callback: (draft: WritableDraft<ProfileModel>) => void,
  ) => void;
};

export function ProfileBackgroundMediaListEditor({
  disabled = false,
  profile,
  onProfileChanged,
}: ProfileBackgroundMediaListEditorProps) {
  return (
    <>
      <h6 className="bp-heading mb-4">Background Media</h6>
      {profile?.background?.backgroundMedia?.map((image, index) => (
        <div key={index} className="mb-4">
          <ProfileBackgroundMediaListEditorEntry
            disabled={disabled}
            image={image}
            onImageChanged={(i) => {
              onProfileChanged((draft) => {
                draft.background = draft.background || {};
                draft.background.backgroundMedia =
                  draft.background.backgroundMedia || [];
                draft.background.backgroundMedia[index] = i ?? "";
              });
            }}
            onImageDeleted={() => {
              onProfileChanged((draft) => {
                draft.background = draft.background || {};
                draft.background.backgroundMedia =
                  draft.background.backgroundMedia || [];
                draft.background.backgroundMedia.splice(index, 1);
              });
            }}
          />
        </div>
      ))}
      <Button
        icon="add"
        intent="primary"
        minimal
        text="Add Background Media"
        onClick={() => {
          onProfileChanged((draft) => {
            draft.background = draft.background || {};
            draft.background.backgroundMedia =
              draft.background.backgroundMedia || [];
            draft.background.backgroundMedia.push("");
          });
        }}
      />
    </>
  );
}
